module.exports = __webpack_public_path__ + "static/media/how_work_2.546b5ad9.svg";